import type { ComponentType } from 'react'
import type { CatalogEntry } from '@kayd/shared'
import { Plate } from './Plate'
import { useScrollProgress } from '../hooks/useEnvironment'

interface CatalogProps {
  games: CatalogEntry[]
  GameView?: ComponentType<{ previewKey: string; active: boolean; visible: boolean }> | undefined
  stageReady: boolean
  /** False under prefers-reduced-motion. Scenes still render, they just hold still. */
  animate: boolean
  /** False while plates carry no artwork. */
  showMedia: boolean
}

export function Catalog({ games, GameView, stageReady, animate, showMedia }: CatalogProps) {
  const [listRef, progress] = useScrollProgress<HTMLDivElement>()

  if (games.length === 0) {
    return <p className="empty">Nothing published yet.</p>
  }

  return (
    <div className="catalog" ref={listRef} id="catalog">
      {/* The weight tracks reading position. Decorative, so hidden from AT. */}
      <div
        className="plumb"
        aria-hidden="true"
        style={{ '--plumb-y': `${(progress * 100).toFixed(2)}%` } as React.CSSProperties}
      >
        <span className="plumb__trail" />
        <span className="plumb__bob" />
      </div>

      {games.map((game, i) => (
        <Plate
          key={game.slug}
          game={game}
          position={i + 1}
          GameView={GameView}
          stageReady={stageReady}
          animate={animate}
          showMedia={showMedia}
        />
      ))}
    </div>
  )
}
